export default {
    isValid(content) {
        if (content === undefined || content === null || content === '') return false
        return true;
    },
    toJpgUrl(url) {
        const pos = url.lastIndexOf('.')
        if (pos !== -1) url = url.substring(0, pos)
        return url + ".jpg"
    },
    buildTree(list) {
        const map = new Map();
        const tree = [];

        // 初始化节点并存入Map
        list.forEach(item => {
            map.set(item.id, { ...item });
        });

        // 建立父子关系
        list.forEach(item => {
            const pid = item.pid;
            if (pid === null || pid === 0) {
                tree.push(map.get(item.id)); // 根节点
            }
            else {
                const parent = map.get(pid);
                if (parent) {
                    // 确保父节点有children数组
                    if (!parent.children) parent.children = [];
                    parent.children.push(map.get(item.id)); // 子节点挂载到父节点
                }
            }
        });

        return tree;
    }
}